
export default class Utils {
  static getEdaban = () => {
    var d = new Date();
    return d.getFullYear() - (7 <= d.getMonth() ? 1988 : 1989);
  }

  static getBunrui = () => {
    var d = new Date();
    var m = d.getMonth();
    if (m < 3 || 7 <= m) return 1;
    return 2;
  }

  static numberToDate = (number) => {
    if (typeof number === 'undefined' || !number) return '';
    //if (number.length !== 8) return number;
    let m = number.match(/^(\d{4})(\d{2})(\d{2})\.?\d*$/);
    if (m) return (' ' + parseInt(m[2],10)).slice(-2) + '月' + (' ' + parseInt(m[3], 10)).slice(-2) + '日';
    return number;
  }
  static hyphenationToDate = (dateText) => {
    if (typeof dateText === 'undefined' || !dateText) return '';
    if (dateText.length !== 10) return dateText;
    let m = dateText.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return (' ' + parseInt(m[2],10)).slice(-2) + '月' + (' ' + parseInt(m[3], 10)).slice(-2) + '日';
    return dateText;
  }

  static getHyphenationDate = (d) => {
    if (!d) d = new Date();
    return d.getFullYear() + '-' + ('00'+(d.getMonth()+1)).slice(-2) + '-' + ('00'+d.getDate()).slice(-2);
  }

  static getTimestamp = () => {
    let d = new Date();
    return d.getFullYear() + '-' + ('00'+(d.getMonth()+1)).slice(-2) + '-' + ('00'+d.getDate()).slice(-2) 
      + ' ' + ('00'+d.getHours()).slice(-2) + ':' + ('00'+d.getMinutes()).slice(-2) + ':' + ('00'+d.getSeconds()).slice(-2);
  }

  static YmdToJDate = (ymd) => {
    if (!ymd) return ymd;
    let m = ymd.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return ymd;
    return m[1]+'年'+parseInt(m[2], 10)+'月'+parseInt(m[3], 10) + '日';
  }

  static YmdToDateObject = (ymd) => {
    if (!ymd) return null;
    var m = ymd.match(/^(\d{4})[^0-9]*(\d{1,2})[^0-9]*(\d{1,2})[^0-9]*$/);
    if (!m) return null;
    let d = new Date();
    d.setDate(1);
    d.setFullYear(m[1]);
    d.setMonth(parseInt(m[2],10)-1);
    d.setDate(parseInt(m[3],10));
    return d;
  }

  static base64ToBlob = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }
  
    return new Blob([bytes], { type: 'application/pdf' });
  };
  
  static getUUID = () => {
    if (crypto) {
      if (crypto.randomUUID) return crypto.randomUUID();
      if (crypto.getRandomValues) {
        let array = new Uint32Array(10);
        crypto.getRandomValues(array);
        let uuid = '';
        uuid += Number(parseInt(array[0].toString()+array[1].toString(), 10)).toString(16).slice(0, 8);
        uuid += '-';
        uuid += Number(array[2]).toString(16).slice(0, 4);
        uuid += '-';
        uuid += Number(array[3]).toString(16).slice(0, 4);
        uuid += '-';
        uuid += Number(array[4]).toString(16).slice(0, 4);
        uuid += '-';
        uuid += Number(parseInt(array[5].toString()+array[6].toString(), 10)).toString(16).slice(0, 12);
        return uuid;
      }
    }

    let uuid = '';
    let r = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    uuid += Number(r).toString(16).slice(0, 8);
    uuid += '-';
    r = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    uuid += Number(r).toString(16).slice(0, 4);
    uuid += '-';
    r = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    uuid += Number(r).toString(16).slice(0, 4);
    uuid += '-';
    r = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    uuid += Number(r).toString(16).slice(0, 4);
    uuid += '-';
    r = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    uuid += Number(r).toString(16).slice(0, 12);
    return uuid;
  }

  static generatePassword = (len, options) => {
    let _opt = {
      alphabet:  (options && options.hasOwnProperty('alphabet'))  ? !!options.alphabet  : true,
      uppercase: (options && options.hasOwnProperty('uppercase')) ? !!options.uppercase : true,
      numbers:   (options && options.hasOwnProperty('numbers'))   ? !!options.numbers   : true,
      avoidConfusingCharacter: (options && options.hasOwnProperty('avoidConfusingCharacter')) ? !!options.avoidConfusingCharacter : true,
    };

    let letters = 'abcdefghijklmnopqrstuvwxyz';
    let numbers = '0123456789';
    let string = _opt.alphabet ? letters : '';
    if (_opt.uppercase) string += letters.toUpperCase();
    if (_opt.numbers) string += numbers;
    if (string.length === 0) return '';
    let _len = len || 8;
    let password = '';
    
    do {
      password = doGenerate();
    }
    while (!check(password, _opt));
    
    return password;
    
    // パスワードの生成
    function doGenerate() {
      let p = '';
      for (let i = 0; i < _len; i++) {
        p += string.charAt(Math.floor(Math.random() * string.length));
      }
      return p;
    }
    
    // 数字、アルファベット大文字、小文字を含むか調べる
    function check(p, _opt) {
      if (_opt.alphabet  && !/[a-z]/.test(p)) return false;
      if (_opt.uppercase && !/[A-Z]/.test(p)) return false;
      if (_opt.numbers   && !/[0-9]/.test(p)) return false;
      if (_opt.avoidConfusingCharacter && /[0O1lI]/.test(p)) return false;
      return true;
    }
  }

  static getUrlVars = () => {
    let searches = window.location.search.replace(/^\?/, '').split('&').reduce((c,v)=>{
      let n = v.split('=');
      c[n[0]]=n[1];
      return c;
    }, {});
    window.history.replaceState(null, '', window.location.pathname);
    return searches;

    /*
    let vars = [], hash;
    var search = (function(){
       if (window.location.search) return window.location.search.replace(/^\?/, '');
       else return window.location.href.slice(window.location.href.indexOf('?') +1);
    })();
    var hashes = (search || '').split('&');
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
    */
  }


  static storeSearchProps = (props) => {
    if (!window.localStorage) return;
    window.localStorage.setItem('search_props', JSON.stringify(props));
  }
  static loadSearchProps = () => {
    if (!window.localStorage) return null;
    let props = window.localStorage.getItem('search_props');
    if (!props) return null;
    return JSON.parse(props);
  }
}